"use strict";
/**
 * Core notification system types
 * Supports multi-channel, multi-provider notification delivery
 * with intelligent account manager targeting based on user roles
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_AM_NOTIFICATION_RULES = exports.NotificationStatus = exports.NotificationPriority = exports.NotificationChannel = exports.NotificationTypes = void 0;
var NotificationTypes;
(function (NotificationTypes) {
    // Order-related notifications
    NotificationTypes["ORDER_SUBMITTED"] = "order_submitted";
    NotificationTypes["ORDER_APPROVED"] = "order_approved";
    NotificationTypes["ORDER_SHIPPED"] = "order_shipped";
    NotificationTypes["ORDER_DELIVERED"] = "order_delivered";
    NotificationTypes["ORDER_FAILED"] = "order_failed";
    NotificationTypes["ORDER_CANCELLED"] = "order_cancelled";
    // Account-related notifications
    NotificationTypes["ACCOUNT_CREATED"] = "account_created";
    NotificationTypes["ACCOUNT_APPROVED"] = "account_approved";
    NotificationTypes["ACCOUNT_SUSPENDED"] = "account_suspended";
    NotificationTypes["ACCOUNT_REACTIVATED"] = "account_reactivated";
    // Verification notifications
    NotificationTypes["VERIFICATION_REQUIRED"] = "verification_required";
    NotificationTypes["VERIFICATION_APPROVED"] = "verification_approved";
    NotificationTypes["VERIFICATION_REJECTED"] = "verification_rejected";
    NotificationTypes["VERIFICATION_REMINDER"] = "verification_reminder";
    // Payment-related notifications
    NotificationTypes["PAYMENT_RECEIVED"] = "payment_received";
    NotificationTypes["PAYMENT_FAILED"] = "payment_failed";
    NotificationTypes["PAYMENT_OVERDUE"] = "payment_overdue";
    NotificationTypes["INVOICE_GENERATED"] = "invoice_generated";
    NotificationTypes["CREDIT_LIMIT_REACHED"] = "credit_limit_reached";
    // System notifications
    NotificationTypes["SYSTEM_MAINTENANCE"] = "system_maintenance";
    NotificationTypes["SECURITY_ALERT"] = "security_alert";
    NotificationTypes["PASSWORD_RESET"] = "password_reset";
    NotificationTypes["LOGIN_ALERT"] = "login_alert";
    // Catalog and pricing updates
    NotificationTypes["CATALOG_UPDATED"] = "catalog_updated";
    NotificationTypes["PRICE_CHANGE"] = "price_change";
    NotificationTypes["PRODUCT_DISCONTINUED"] = "product_discontinued";
    // Bulk operations
    NotificationTypes["BULK_ORDER_COMPLETED"] = "bulk_order_completed";
    NotificationTypes["BULK_OPERATION_FAILED"] = "bulk_operation_failed";
    // Payout notifications
    NotificationTypes["PAYOUT_CREATED"] = "payout_created";
    NotificationTypes["PAYOUT_SENT"] = "payout_sent";
    NotificationTypes["PAYOUT_CONFIRMED"] = "payout_confirmed";
    NotificationTypes["PAYOUT_CANCELLED"] = "payout_cancelled";
    // Product request notifications
    NotificationTypes["PRODUCT_REQUEST_CREATED"] = "product_request_created";
    NotificationTypes["PRODUCT_REQUEST_STATUS_CHANGED"] = "product_request_status_changed";
    NotificationTypes["PRODUCT_REQUEST_COMMENT_ADDED"] = "product_request_comment_added";
})(NotificationTypes || (exports.NotificationTypes = NotificationTypes = {}));
var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["EMAIL"] = "email";
    NotificationChannel["SMS"] = "sms";
    NotificationChannel["PUSH"] = "push";
    NotificationChannel["IN_APP"] = "in_app";
    NotificationChannel["SLACK"] = "slack";
})(NotificationChannel || (exports.NotificationChannel = NotificationChannel = {}));
var NotificationPriority;
(function (NotificationPriority) {
    NotificationPriority["LOW"] = "low";
    NotificationPriority["NORMAL"] = "normal";
    NotificationPriority["HIGH"] = "high";
    NotificationPriority["URGENT"] = "urgent";
})(NotificationPriority || (exports.NotificationPriority = NotificationPriority = {}));
var NotificationStatus;
(function (NotificationStatus) {
    NotificationStatus["PENDING"] = "pending";
    NotificationStatus["PROCESSING"] = "processing";
    NotificationStatus["SENT"] = "sent";
    NotificationStatus["DELIVERED"] = "delivered";
    NotificationStatus["FAILED"] = "failed";
    NotificationStatus["BOUNCED"] = "bounced";
    NotificationStatus["CANCELLED"] = "cancelled";
})(NotificationStatus || (exports.NotificationStatus = NotificationStatus = {}));
/**
 * Default account manager notification rules
 */
exports.DEFAULT_AM_NOTIFICATION_RULES = {
    notificationTypes: [
        NotificationTypes.ORDER_FAILED,
        NotificationTypes.PAYMENT_FAILED,
        NotificationTypes.VERIFICATION_REQUIRED,
        NotificationTypes.VERIFICATION_REJECTED,
        NotificationTypes.ACCOUNT_SUSPENDED,
        NotificationTypes.CREDIT_LIMIT_REACHED,
    ],
    applicableRoles: ['physician', 'physician_readonly'],
    deliveryMethod: 'separate',
    includeContext: true,
};
//# sourceMappingURL=notifications.js.map